import { Breadcrumb, Button, PageHeader } from 'antd';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AdiveryLogsTable from '../components/tables/adivery-logs-table';

const AdiveryLogsListRoute: FC = () => {
  const navigate = useNavigate()

  return (<>
    <PageHeader
      title="ادیوری لاگ"
      style={{ padding: " 16px 0" }}
onBack={() => navigate(-1)}
    />
    <AdiveryLogsTable />
  </>);
}

export default AdiveryLogsListRoute;
